import { render, staticRenderFns } from "./AppError.vue?vue&type=template&id=28323f33&"
import script from "./AppError.vue?vue&type=script&lang=ts&"
export * from "./AppError.vue?vue&type=script&lang=ts&"
import style0 from "./AppError.vue?vue&type=style&index=0&id=28323f33&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports